<template>
  <div class="page-view">
    <img :src="image" alt="" v-if="image" />
    <ul class="list">
      <li
        v-for="item in meetings"
        :key="item.meetingId"
        @click="toAPP(item.meetingId)"
        class="item"
      >
        <label
          class="label"
          :class="{ gray: item.isEnd }"
          v-if="item.unlockType == 1"
          >固定日期解锁</label
        >
        <label
          class="label"
          :class="{ gray: item.isEnd }"
          v-if="item.unlockType == 2"
          >闯关模式</label
        >
        <label
          class="label"
          :class="{ gray: item.isEnd }"
          v-if="item.unlockType == 3"
          >随到随学</label
        >
        <div class="cover">
          <div class="title">{{ item.meetingName }}</div>
          <img :src="item.indexImage" alt="" />
        </div>
        <div class="info">
          <span class="time" v-if="item.time"><i></i> {{ item.time }}</span>
          <i v-else></i>
          <div class="right">
            <img
              src="@/assets/icon/practice_task_completed.png"
              alt=""
              class="joined"
              :class="{ show: item.isBuy }"
            />
            <span class="join" v-if="!item.isEnd">点击立即参与</span>
            <span class="join gray" v-if="item.isEnd">此班期已结束</span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { hostPath } from '@utils/basePath'
import { videoReq } from '@/api/index'
import { defineComponent } from 'vue'
import { jumpModuleApp, appPort } from '@/widget/index'
import { getUserId } from '@/widget/index'

export default defineComponent({
  data() {
    return {
      albumId: this.$route.query.albumId,
      meetings: [],
      image: ''
    }
  },
  created() {
    if (!this.albumId) {
      this.$toast('缺少参数')
      return false
    }
    this.$showLoading()
    videoReq
      .getNewCourse({
        query: { userId: getUserId() },
        params: { albumId: this.albumId }
      })
      .then(res => {
        if (res.code === 200) {
          this.image = res.data.image
          this.meetings = res.data.meetings
        } else {
          this.$toast(res.message)
        }
        this.$hideLoading()
      })
  },
  methods: {
    toAPP(meetingId) {
      let url = `${hostPath}/learn/course/train/${meetingId}`
      if (appPort()) {
        jumpModuleApp({
          typeId: 'h5',
          url
        })
      } else {
        location.href = url
      }
    }
  }
})
</script>

<style lang="scss" scoped>
.page-view {
  background: #f5f5f7;
  min-height: 100vh;
}
.list {
  box-sizing: border-box;
  padding: 0.24rem 0.32rem;
}
.item {
  background: #ffffff;
  border-radius: 0.16rem;
  box-sizing: border-box;
  padding: 0.32rem 0.2rem 0 0.2rem;
  margin-bottom: 0.24rem;
  overflow: hidden;
  position: relative;
  z-index: 3;
  .info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .joined {
        width: 0.84rem;
        height: 0.84rem;
        margin-right: 0.16rem;
        opacity: 0;
        &.show {
          opacity: 1;
        }
      }
      .join {
        font-size: 0.28rem;
        font-weight: bold;
        color: #ff6600;
        line-height: 0.4rem;
        white-space: nowrap;
        &.gray {
          color: #969799;
        }
      }
    }
    .time {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 0.24rem;
      color: #626366;
      white-space: nowrap;
      i {
        display: inline-block;
        width: 0.26rem;
        height: 0.26rem;
        display: inline-block;
        background: url('~@/assets/icon/icon_clock.png') no-repeat center;
        background-size: 100% 100%;
        margin-right: 0.08rem;
      }
    }
  }
  img {
    display: block;
  }
  .label {
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    height: 0.4rem;
    text-align: center;
    background: #fee8cb;
    border-radius: 0rem 0.16rem 0rem 0.08rem;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 2;
    font-size: 0.24rem;
    font-weight: 500;
    color: #ff6600;
    padding: 0 0.2rem;
    &.gray {
      background: #e1e2e6;
      color: #969799;
    }
  }
  .cover {
    border-radius: 0.12rem;
    position: relative;
    overflow: hidden;
    z-index: 1;
    height: 358px;
    .title {
      height: 1.16rem;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.5) 100%
      );
      border-radius: 0.12rem;
      position: absolute;
      width: 100%;
      z-index: 1;
      bottom: 0;
      left: 0;
      box-sizing: border-box;
      padding: 0.52rem 0.2rem 0.2rem 0.2rem;
      font-size: 0.32rem;
      color: #ffffff;
      line-height: 0.44rem;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
